import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6f6904a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "check-symptoms-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-info" }, " Está sentindo algum sintoma como tosse, febre, dor de cabeça, dor de garganta, dores no corpo, coriza ou nariz escorrendo, dificuldades para respirar, diarréia ou outros? ", -1))
const _hoisted_3 = { class: "question-options" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "open-sans-font" }, "Sim, um ou mais sintomas", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "open-sans-font" }, "Não, nenhum sintoma", -1))
const _hoisted_6 = { class: "error-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Campo de preenchimento obrigatório.", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_floating_card = _resolveComponent("floating-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "6",
      stepTitle: "Informe se você tem sintomas",
      nextButtonActive: _ctx.canJumpNext,
      onNextStep: _cache[2] || (_cache[2] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[3] || (_cache[3] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("input", {
              name: "symptoms",
              type: "radio",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSymptoms('yes')))
            }, null, 32),
            _hoisted_4
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("input", {
              name: "symptoms",
              type: "radio",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSymptoms('no')))
            }, null, 32),
            _hoisted_5
          ], 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, _hoisted_8, 512), [
          [_vShow, _ctx.hasError]
        ])
      ]),
      _: 1
    }, 8, ["nextButtonActive"])
  ]))
}